<template>
  <div>
    <vxe-toolbar
      id="toolbarId_st8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter()">
          查询
        </el-button>
        <el-button
          v-if="getLimit('Balance_detail_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      row-id="id"
      height="400"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="客户名称"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运单号"
          min-width="170"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidAmount"
          title="变动金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.paidAmount" placeholder="请输入内容" clearable /> -->
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidLineName"
          title="变动类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidLineType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v, k) in paidLineTypeMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidItemName"
          title="变动原因"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidItem"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v, k) in paidItemMap"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="accountAmountBehind"
          title="账户余额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAccountAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAccountAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="businessPerson"
          title="操作人"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.businessPerson"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidRemark"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.paidRemark"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          show-header-overflow
          show-overflow
          title="变动时间"
          min-width="240"
          sortable
          :resizable="false"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { shipmentPaidRecord } from "@/api/invoice";
import { isNumber } from "@/utils/validate";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/shipmentPaidRecord/exportShipmentPaidRecord", //导出接口
        name: "变动明细"
      },
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        userCode: "",
        paidAmountMin: "",
        paidAmountMax: "",
        paidAccountAmountMin: "",
        paidAccountAmountMax: ""
      },
      emptyQuery: {},
      // Pagingconf: [],
      // 0-线下充值，1-发货保证金 2-运费 3-保费 4-罚款 5-提现 6-信息费,7-车队分账 8-退款，,9-凭证支付,10-凭证提现，11-线上充值，12-网商保证金
      paidItemMap: {
        0: "线下充值",
        1: "发货保证金",
        2: "运费",
        3: "保费",
        4: "罚款",
        5: "提现",
        6: "信息费",
        7: "车队分账",
        8: "退款",
        9: "凭证支付",
        10: "凭证提现",
        11: "线上充值",
        12: "网商保证金"
      },
      paidLineTypeMap: { 0: "在线支付", 1: "转账支付" }
    };
  },
  created() {
    this.emptyQuery = JSON.stringify(this.listQuery);
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    findList(code) {
      this.loading = true;
      this.tableData = [];
      if (code) {
        this.listQuery = JSON.parse(this.emptyQuery);
        this.listQuery.userCode = code;
        this.initQuery = JSON.stringify(this.listQuery);
      }
      return new Promise(resolve => {
        shipmentPaidRecord(this.listQuery).then(response => {
          this.tableData = response.data.records;
          //response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>
